import React, { useState, useEffect } from 'react';
import Listing from "../../../assets/components/listing/Listing";
import Eyeicon from '../../../assets/images/eye_icon.png';
import ResizeDetector from "react-resize-detector";
import { TransitionGroup } from 'react-transition-group';
import styles from '../../../assets/css/rstyling.module.css';
import Projecticon from '../../../assets/images/project_header_icon.png';
import { Card, CardBody } from "reactstrap";
import PageHeader from '../../../assets/components/pageheader/PageHeader';
import LoadingOverlay from 'react-loading-overlay-ts';
import Loader from "react-loaders";
import { useDispatch, useSelector } from 'react-redux';
import { get_reward_requests, update_reward_requests, search_reward_user } from '../../../actions/rewards_actions';
import SettingIcon from '../../../assets/images/settings_icon_sm.png';
import Search from '../../../assets/images/search_icon.png';

export default function RewardsTable() {
    const dispatch = useDispatch();
    const rewardState = useSelector(state => state.Reward);

    const [isLoading, setLoading] = useState(true);
    const [rewardsData, set_rewardsData] = useState([]);
    const [searchString, setSearchString] = useState('');

    const [processing, set_processing] = useState({ status: false, user: '', rewardId: '' });
    const [completed, set_completed] = useState({ status: false, user: '', rewardId: '' });
    const [rejected, set_rejected] = useState({ status: false, user: '', rewardId: '' });
    const [scheduled, set_scheduled] = useState({ status: false, user: '', rewardId: '' });

    const [rewardsCol] = useState([
        { Name: "Email", Type: 'string', key: 'rewardEmail' },
        { Name: "Brand", Type: 'string', key: 'rewardBrand', fixWidth: 20 },
        { Name: "Redeem Points", Type: 'number', key: 'rewardPoints', fixWidth: 10 },
        { Name: "Redeem Cash", Type: 'string', key: 'rewardCash', fixWidth: 10 },
        { Name: "Status", Type: 'string', key: 'rewardStatus', fixWidth: 20 },
        { Name: "Applied At", Type: 'string', key: 'rewardDate', fixWidth: 20 },
        {
            Name: "Action", Type: 'action', options: [
                {
                    icon: Eyeicon,
                    type: 'dropdown',
                    droplist: [{ Name: 'View User Details', viewType: 'reward-user-details', url: "/admin/view-user/rewards" }]
                },
                {
                    icon: SettingIcon,
                    type: 'dropdown',
                    droplist: [
                        { Name: 'Processing', viewType: 'approve-reward', setProcessing: set_processing, setCompleted: set_completed, setRejected: set_rejected, setScheduled: set_scheduled },
                        { Name: 'Completed', viewType: 'complete-reward', setCompleted: set_completed, setProcessing: set_processing, setRejected: set_rejected, setScheduled: set_scheduled },
                        { Name: 'Rejected', viewType: 'reject-reward', setRejected: set_rejected, setProcessing: set_processing, setCompleted: set_completed, setScheduled: set_scheduled },
                        { Name: 'Scheduled', viewType: 'schedule-reward', setScheduled: set_scheduled, setProcessing: set_processing, setCompleted: set_completed, setRejected: set_rejected },
                    ]
                },
            ]
        },
    ]);

    const getRewardsListing = (currentPage = rewardState.currentPage, dataLimit = rewardState.dataLimit) => {
        setLoading(true);
        dispatch(get_reward_requests({ page: currentPage, limit: dataLimit }))
            .then((response) => {
                set_rewardsData(response.payload.content.rewards);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }

    useEffect(() => {
        getRewardsListing(rewardState.currentPage ,  rewardState.dataLimit);
    }, []);



    useEffect(() => {
        
            const timer = setTimeout(()=> {
                if (searchString.trim().length > 0) {
                    //console.log("search")
            setLoading(true);
     dispatch(search_reward_user({ search: searchString, page: 1, limit: rewardState.dataLimit}))
                .then(response => {
                    set_rewardsData(response.payload.content.rewardRequests);
                    setLoading(false);
                })
                .catch(()=> setLoading(false));
        } else {
            setLoading(true);
            getRewardsListing(rewardState.currentPage, rewardState.dataLimit); 
        }
    
            },500)
            return ()=> clearTimeout(timer)
           
    }, [searchString]);

    useEffect(() => {
        const active = processing.status ? { key: 'Processing', data: processing } :
                       completed.status ? { key: 'Completed', data: completed } :
                       rejected.status ? { key: 'Rejected', data: rejected } :
                       scheduled.status ? { key: 'Scheduled', data: scheduled } : null;

        if (active && active.data.user && active.data.rewardId) {
            dispatch(update_reward_requests({
                status: active.key,
                rewardId: active.data.rewardId
            }, active.data.user))
            .then(() => {
                if (searchString.trim().length > 0) {
                    dispatch(search_reward_user({ search: searchString, page: 1, limit: rewardState.dataLimit }))
                        .then(res => set_rewardsData(res.payload.content.rewardRequests));
                } else {
                    getRewardsListing(rewardState.currentPage, rewardState.dataLimit);
                }
                
                set_processing({ status: false, user: '', rewardId: '' });
                set_completed({ status: false, user: '', rewardId: '' });
                set_rejected({ status: false, user: '', rewardId: '' });
                set_scheduled({ status: false, user: '', rewardId: '' });
            });
        }
    }, [processing, completed, rejected, scheduled]);

    return (
        <ResizeDetector
            handleWidth
            render={({ width }) => (
                <TransitionGroup component="div" transitionName="TabsAnimation" transitionAppear={true}
                    transitionAppearTimeout={0} transitionEnter={false} transitionLeave={false}>
                    <div className="project_header">
                        <PageHeader heading="Rewards" img={Projecticon} />
                    </div>
                    <Card className="main-card mb-3">
                        <nav className="navbar navbar-expand-sm navbar-light" style={{ backgroundColor: '#006FA7', borderRadius: '5px 5px 0 0' }}>
                            <div className="text-white menu-header-title text-capitalize">Reward Requests List</div>
                            <div className={width <= 470 ? "" : "collapse navbar-collapse"}>
                                <ul className="navbar-nav mr-auto"></ul>
                                <div className="form-inline my-2 my-sm-0 " style={{ marginRight: '-2.5rem' }}>
                                    <div className="input-group input-group-sm w-75">
                                        <div className="input-group-prepend border-0">
                                            <span className={`bg-white my-sm-0 input-group-text form-control-sm ${styles.search_input}`}>
                                                <img src={Search} alt="search" />
                                            </span>
                                        </div>
                                        <input 
                                            className={`form-control input-sm mr-sm-2 p-0 m-0 border-left-0 form-control-sm ${styles.search_input}`} 
                                            type="search" 
                                            placeholder="Search" 
                                            onChange={(e) => setSearchString(e.target.value)} 
                                        />
                                    </div>
                                </div>
                            </div>
                        </nav>
                        <LoadingOverlay tag="div" active={isLoading}
                            styles={{ overlay: (base) => ({ ...base, background: "#fff", opacity: 0.5 }) }}
                            spinner={<Loader color="#6c757d" active type="ball-pulse" />}>
                            <CardBody className="p-0">
                                <div className="table_border">
                                    <Listing 
                                        columnName={rewardsCol}
                                        data={rewardsData}
                                        currentPage={rewardState.currentPage || 1}
                                        dataLimit={rewardState.dataLimit || 5}
                                        totalPages={rewardState.totalPages || 1}
                                        getListingData={(page, limit) => getRewardsListing(page, limit)}
                                        startLoading={() => setLoading(true)}
                                    />
                                </div>
                            </CardBody>
                        </LoadingOverlay>
                    </Card>
                </TransitionGroup>
            )}
        />
    );
}